import React from 'react';
import dayjs from 'dayjs';

/**
 * ADD-ON: shows the biometric first punch in and last punch out of one day,
 * under the attendance status of a day cell.
 *
 * This file is only used by MarkAttendanceStyle.js. Nothing else imports it,
 * so deleting the add-on block there switches this off completely.
 *
 * The times come from `row.punchDetails`, which the backend adds at the end of
 * the attendance response, keyed by day of month. When the backend add-on is
 * disabled that field is missing and this renders nothing at all.
 *
 * @param {object} params - the MUI DataGrid cell params
 */
const PunchDetails = ({ params }) => {
  // `params.field` is the day column index ("0" for day 1, "1" for day 2, ...)
  // while punchDetails is keyed by day of month, so shift by one.
  const dayOfMonth = Number(params.field) + 1;
  const punchObj = params.row?.punchDetails?.[dayOfMonth] || {};
  const { firstTimestamp, lastTimestamp } = punchObj;

  const firstTime = firstTimestamp ? dayjs(firstTimestamp).format('hh:mm A') : null;
  const lastTime = lastTimestamp ? dayjs(lastTimestamp).format('hh:mm A') : null;

  // No punches on this day, so add nothing under the status.
  if (!firstTime && !lastTime) return null;

  return (
    <div style={{ fontSize: '10px', color: '#555', whiteSpace: 'nowrap', fontWeight: 'normal' }}>
      {/* A missing punch shows as --:-- so it is obvious which one is absent. */}
      {firstTime || '--:--'}
      {' - '}
      {lastTime || '--:--'}
    </div>
  );
};

export default PunchDetails;
